// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__Vj7U6","milestoneBackground":"milestone_milestoneBackground__uWo19"};